import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Icon } from 'edcom-ui';
import AppLink from '../links/AppLink';

import styles from './Breadcrumbs.module.less';
import RequestContext from '../../services/RequestContext';

export default function Breadcrumbs({
  title,
  contentType,
  grades = [],
  subjects = [],
  path,
  className,
  ...otherProps
}) {
  const { hostname } = useContext(RequestContext);

  const links = [
    {
      url: '/resources/',
      display: 'Entire Library',
    },
    {
      url: `/${path}/`,
      display: contentType,
    },
  ];

  let currentPath = `/${path}/`;

  if (grades.length) {
    const grade = grades[0];
    currentPath += `${grade.urlName}/`;
    links.push({
      url: `${currentPath}`,
      display: grade.name,
    });
  }

  if (subjects.length) {
    const subject = subjects[0];
    currentPath += `${subject.urlName}/`;
    links.push({
      url: `${currentPath}`,
      display: subject.name,
    });
  }

  // Add current page itself to the breadcrumb list
  links.push({
    display: title,
  });

  return (
    <div className={clsx(styles.container, className)} {...otherProps}>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'http://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: links.map(({ url, display }, i) => {
              const listItem = {
                '@type': 'ListItem',
                position: i + 1,
                name: display,
              };

              if (url) {
                listItem.item = `https://${hostname}${url}`;
              }

              return listItem;
            }),
          }),
        }}
      />
      <div className={styles.guideText}>You are here: </div>
      <div>
        {links.map(({ url, display }) => {
          if (!url) {
            return (
              <span className={styles.link} key={display}>
                {display}
              </span>
            );
          }

          return (
            <React.Fragment key={url}>
              <AppLink href={url} className={styles.link}>
                {display}
              </AppLink>
              <Icon
                name="right-open"
                className={styles.rightOpen}
                isImg={false}
              />
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}

Breadcrumbs.propTypes = {
  title: PropTypes.string.isRequired,
  contentType: PropTypes.string.isRequired,
  grades: PropTypes.array.isRequired,
  subjects: PropTypes.array.isRequired,
  path: PropTypes.string.isRequired,
  className: PropTypes.string,
};
